var render = function render(){var _vm=this,_c=_vm._self._c;return _c('your-data-is-safe-template',{attrs:{"object-medical-use":_vm.objectMedicalUse,"marketing-use":_vm.marketingUse,"locale":_vm.patient.locale,"language-options":_vm.languageOptions},on:{"change-language":_vm.onLanguageSelect,"input":_vm.onFieldChange,"cancel":_vm.onCancel,"continue":_vm.onAgreeAndContinue}})
}
var staticRenderFns = []

export { render, staticRenderFns }